import React, {useEffect, useState} from "react";
import BigCalendar from "react-big-calendar";
import moment from "moment";
require('moment/locale/es.js');

const localizer = BigCalendar.momentLocalizer(moment);

export default function CalendarContainer(props) {
    const [eventsList, setEventsList] = useState([]);

    useEffect(() => {
        setEventsList(props.events);
    })

    const onEventClick = (event) => {
        props.onEventClick(event);
    };

    const onSelectSlot = ({start, end, action}) => {
        if (action === 'doubleClick'){
            const startDDMM = start.getDate() + '/' + (start.getMonth() + 1);
            const endDDMM = end.getDate() + '/' + (end.getMonth() + 1);

            props.createNew(startDDMM, endDDMM);
        }
    };

    const eventColors = (event, start, end, isSelected) => {
        let backgroundColor = "event-";
        event.color
            ? (backgroundColor = backgroundColor + event.color)
            : (backgroundColor = backgroundColor + "default");
        return {
            className: backgroundColor
        };
    };

    return (
        <div className={"div-calendar-container"}>
            {
                eventsList.length > 0 ?
                    <BigCalendar
                        localizer={localizer}
                        selectable
                        events={eventsList}
                        defaultView="month"
                        scrollToTime={new Date(2019, 1, 1, 6)}
                        defaultDate={new Date()}
                        onSelectEvent={event => onEventClick(event)}
                        onSelectSlot={onSelectSlot}
                        eventPropGetter={eventColors}
                        views={{month: true}}
                        messages={{'today': "Hoy", "previous": 'Antrerior', "next": "Siguiente"}}
                    /> : null
            }

        </div>
    )
}